import DeferImages from "./DeferImages";

const LearningResources = () => {
  const dropdown: HTMLSelectElement = document.querySelector(
    "#BusinessAreaFilter"
  );
  const partialWrapper: HTMLElement = document.querySelector(
    ".partial-wrapper"
  );

  dropdown.onchange = (e: any) => {
    const area: string = e.target.value;
    const areaEncoded = encodeURIComponent(area);
    const queryString = `businessarea=${areaEncoded}`;

    fetch(`${partialWrapper.dataset.partialUrl}&${queryString}`)
      .then((e) => e.text())
      .then((f) => {
        partialWrapper.innerHTML = f;
        window.history.replaceState(null, null, areaEncoded ? `?${queryString}` : window.location.pathname);
        new DeferImages();
      });
  };
};

export default LearningResources;
